import fetch from '@/plugin/axios'

// 新增参数
export function getAdde (query) {
  return fetch({
    url: '/api/goods/param-config/add',
    method: 'Post',
    data: query
  })
}
// 查询列表
export function getConfig (query) {
  return fetch({
    url: '/api/goods/param-config/list',
    method: 'Post',
    data: query
  })
}
// 编辑
export function getEdit (id, name) {
  return fetch({
    url: `/api/goods/param-config/edit/${id}`,
    method: 'Post',
    headers: { 'Content-Type': 'application/json' },
    data: name
  })
}
// 删除
export function getDel (id, name) {
  return fetch({
    url: `/api/goods/param-config/${id}`,
    method: 'DELETE',
    data: name
  })
}

// 商品信息
export function getInfo (id, name) {
  return fetch({
    url: `/api/goods/spu/info/${id}`,
    method: 'Put'
  })
}

// 修改/编辑商品
export function getMEdit (id, name) {
  return fetch({
    url: `/api/goods/spu/edit/${id}`,
    method: 'Post',
    data: name
  })
}

// 删除商品
export function getSpu (id) {
  return fetch({
    url: `/api/goods/spu/${id}`,
    method: 'DELETE'
  })
}
